import React from "react";
import Comingsoonpage from "../../../common/Comingsoon";

const RecurringToDoList = () => {
  return <div><Comingsoonpage /></div>;
};

export default RecurringToDoList;
